import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'gioNameFormatter'
})
export class GioNameFormatterPipe implements PipeTransform {

  transform(value: string, options: 'reduced'): unknown {
    if (!value) {
      return '';
    }

    let names = value.split(' ');
    if (!options) {
      options = 'reduced';
    }

    let response = '';
    response = names[0];
    if (names.length > 1) {
      response += ` ${names.last()}`
    }

    return response.capitalize();
  }

}
